// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tbody.budget-table-body > tr:nth-child(even) > td {
  background-color: #F4F4F4;
}

tbody.budget-table-body > tr:nth-child(odd) > td {
  background-color: white;
}

.budget-table-header th {
  background-color: #004B22;
  color: #fff;
}

.budget-table-header th.lwb,
tbody.budget-table-body > tr > td.lwb {
  border-left: 2px solid white;
}

tbody.budget-table-body > tr > td.new {
  background-color: rgb(0%, 59.4117647059%, 26.9333333333%);
}

tbody.budget-table-body > tr > td.comment {
  background-color: rgb(8.2180392157%, 70.8015686275%, 39.8258823529%);
}

.budget-table-header .standard,
tbody.budget-table-body > tr > td.standard {
  background-color: #2A8A8D;
}

tbody.budget-table-body > tr:nth-child(even) > td.standard {
  background-color: rgb(14.1755062681%, 46.5766634523%, 47.5891996143%);
}

.budget-table-header .peak,
tbody.budget-table-body > tr > td.peak {
  background-color: #4E9EA0;
}

tbody.budget-table-body > tr:nth-child(even) > td.peak {
  background-color: rgb(27.3109243697%, 55.3221288515%, 56.0224089636%);
}

.budget-table-header .off-peak,
tbody.budget-table-body > tr > td.off-peak {
  background-color: #6F9D9F;
}

tbody.budget-table-body > tr:nth-child(even) > td.off-peak {
  background-color: rgb(38.3529411765%, 56.7303921569%, 57.5294117647%);
}

.budget-table-header .total,
tbody.budget-table-body > tr > td.total {
  background-color: #76A25B;
}

tbody.budget-table-body > tr:nth-child(even) > td.total {
  background-color: rgb(41.6104781834%, 57.1262497094%, 32.0894365651%);
}

.budget.bs {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}`, "",{"version":3,"sources":["webpack://./src/style/transformer/budget/budgetTable.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;AACJ;;AAEA;;EAEI,4BAAA;AACJ;;AAEA;EACI,yDAAA;AACJ;;AAEA;EACI,oEAAA;AACJ;;AAEA;;EAEI,yBAAA;AACJ;;AAEA;EACI,qEAAA;AACJ;;AAEA;;EAEI,yBAAA;AACJ;;AAEA;EACI,qEAAA;AACJ;;AAEA;;EAEI,yBAAA;AACJ;;AAEA;EACI,qEAAA;AACJ;;AAEA;;EAEI,yBAAA;AACJ;;AAEA;EACI,qEAAA;AACJ;;AAEA;EACI,mDAAA;AACJ","sourcesContent":["tbody.budget-table-body > tr:nth-child(even) > td {\n    background-color: #F4F4F4;\n}\n\ntbody.budget-table-body > tr:nth-child(odd) > td {\n    background-color: white;\n}\n\n.budget-table-header th {\n    background-color: #004B22;\n    color: #fff;\n}\n\n.budget-table-header th.lwb,\ntbody.budget-table-body > tr > td.lwb {\n    border-left: 2px solid white;\n}\n\ntbody.budget-table-body > tr > td.new {\n    background-color: lighten(#004B22, 15%);\n}\n\ntbody.budget-table-body > tr > td.comment {\n    background-color: lighten(#0d703f, 15%);\n}\n\n.budget-table-header .standard,\ntbody.budget-table-body > tr > td.standard {\n    background-color: #2A8A8D;\n}\n\ntbody.budget-table-body > tr:nth-child(even) > td.standard {\n    background-color: darken(#2A8A8D, 5%);\n}\n\n.budget-table-header .peak,\ntbody.budget-table-body > tr > td.peak  {\n    background-color: #4E9EA0;\n}\n\ntbody.budget-table-body > tr:nth-child(even) > td.peak {\n    background-color: darken(#4E9EA0, 5%);\n}\n\n.budget-table-header .off-peak,\ntbody.budget-table-body > tr > td.off-peak  {\n    background-color: #6F9D9F;\n}\n\ntbody.budget-table-body > tr:nth-child(even) > td.off-peak {\n    background-color: darken(#6F9D9F, 5%);\n}\n\n.budget-table-header .total,\ntbody.budget-table-body > tr > td.total  {\n    background-color: #76A25B;\n}\n\ntbody.budget-table-body > tr:nth-child(even) > td.total {\n    background-color: darken(#76A25B, 5%);\n}\n\n.budget.bs {\n    box-shadow: 0px 3px 6px #00000029;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
